export default function Footer() {
  return(
    <footer className="footer">
      <p className="footer__copyright">Георгий Горчев &copy; 2020 Mesto Russia</p>
    </footer>
  )
}
